import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import redirects from "../redirects";

const RedirectMiddleware = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const trackingParams = ["trk", "ref", "pos", "cmd"];
    const hasTracking = trackingParams.some((p) => params.has(p));

    if (hasTracking) {
      navigate("/", { replace: true });
      return;
    }

    const redirectPath = redirects[location.pathname];
    if (redirectPath && redirectPath !== location.pathname) {
      navigate(redirectPath, { replace: true });
      return;
    }

    setChecked(true);
  }, [location, navigate]);

  if (!checked) return null; // ⛔ block render

  return children;
};

export default RedirectMiddleware;
